import { createCommands } from 'utils/commands';

export const conversationCopilotDropdownCommands = createCommands([
  {
    group: 'conversation',
    label: 'Translate conversation',
    name: 'translate',
    description: 'Translates all messages in the conversation',
  },
  {
    group: 'conversation',
    label: 'Toggle show/hide conversation summary',
    name: 'summary',
    description: 'Toggle visibility of the summary of the conversation',
  },
]);
